<template>
  <InfuseDescriptionList :rows="rows" :item="item" :loading="loading" />
</template>

<script lang="ts" setup>
import { InfuseDescriptionList } from '@infuse/ui/components';
import { UiDescriptionListRow } from '@infuse/ui/domain';
import { computed, ComputedRef } from 'vue';
import { useI18n } from 'vue-i18n';
import { User } from '@infuse/e-connector/user/domain';

interface Props {
  item: User;
  loading?: boolean;
}

withDefaults(defineProps<Props>(), {
  loading: false
});

const { t } = useI18n();

const rows: ComputedRef<UiDescriptionListRow[]> = computed(() => [
  {
    name: 'id',
    term: t('e_connector.common.user.id'),
    detailField: 'id'
  },
  {
    name: 'name',
    term: t('e_connector.common.user.name'),
    detailField: 'name'
  }
]);
</script>
